import { render, staticRenderFns } from "./ChannelChange.vue?vue&type=template&id=0fd0b831"
import script from "./ChannelChange.vue?vue&type=script&lang=ts"
export * from "./ChannelChange.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports